import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { TextField } from "@material-ui/core";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import {
  makeBackendAPIRequest,
  backendBaseURL,
} from "../api_utilities/backend";
import PlaylistRuleGroup from "./PlaylistRuleGroup";
import { makeSpotifyAPIRequest } from "../api_utilities/spotify";

const useStyles = (theme) => ({
  root: {
    width: "100%",
    boxShadow:
      "0px 2px 1px -1px rgba(0,0,0,0.4), 0px 1px 1px 0px rgba(0,0,0,0.28), 0px 1px 3px 0px rgba(0,0,0,0.24)",
  },
  ratingComplete: {
    "& .MuiRating-iconFilled": {
      color: theme.palette.primary.dark,
    },
  },
  ratingIncomplete: {
    "& .MuiRating-iconFilled": {
      color: theme.palette.action.selected,
    },
    "& .MuiRating-iconEmpty": {
      color: theme.palette.action.hover,
    },
  },
  spanning: {
    width: "100%",
  },
});

class PlaylistAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, name: props.name, rules: props.rules };
  }

  openOrCloseAccordion = () => {
    this.setState((prevState) => {
      return {
        isOpen: !prevState.isOpen,
      };
    });
  };

  updatePlaylistName = async (e) => {
    this.setState({ name: e.target.value });
    await this.savePlaylistName();
  };

  savePlaylistName = AwesomeDebouncePromise(() => {
    const { name } = this.state;
    const { id } = this.props;

    let url = new URL(backendBaseURL + "/playlist/update_playlist_name");
    makeBackendAPIRequest({
      url: url,
      method: "POST",
      body: {
        id_spotify: id,
        name: name,
      },
      onSuccessCallback: () => {},
      onFailureCallback: () => {},
    });

    url = new URL("https://api.spotify.com/v1/playlists/" + id);
    makeSpotifyAPIRequest({
      url: url,
      method: "PUT",
      body: {
        name: name,
      },
      onNoContentCallback: () => {},
      onSuccessCallback: () => {},
      onFailureCallback: () => {},
    });
  }, 1000);

  onPlaylistNameKeyDown = (event) => {
    if (event.key === "Enter") {
      this.setState({ isOpen: false });
    }
  };

  onChangeOuterOperator = (newOperator) => {
    const { id } = this.props;
    const { rules } = this.state;

    const outerKey = rules.and != null ? "and" : "or";
    const outerValue = rules[outerKey];
    const newRules = {};
    newRules[newOperator] = outerValue;

    this.setState({ rules: newRules });

    const url = new URL(backendBaseURL + "/playlist/update_playlist_rules");
    makeBackendAPIRequest({
      url: url,
      method: "POST",
      body: {
        id_spotify: id,
        rules: JSON.stringify(newRules),
      },
      onSuccessCallback: this.updatePlaylistOnSpotify,
      onFailureCallback: () => {},
    });
  };

  onChangeOuterValue = (newOuterValue) => {
    const { id } = this.props;
    const { rules } = this.state;

    const outerKey = rules.and != null ? "and" : "or";
    const newRules = {};
    newRules[outerKey] = newOuterValue;

    this.setState({ rules: newRules });

    const url = new URL(backendBaseURL + "/playlist/update_playlist_rules");
    makeBackendAPIRequest({
      url: url,
      method: "POST",
      body: {
        id_spotify: id,
        rules: JSON.stringify(newRules),
      },
      onSuccessCallback: this.updatePlaylistOnSpotify,
      onFailureCallback: () => {},
    });
  };

  updatePlaylistOnSpotify = (ids) => {
    const { id } = this.props;

    const first100IDs = ids.slice(0, 100);

    const url = new URL(`https://api.spotify.com/v1/playlists/${id}/tracks`);
    makeSpotifyAPIRequest({
      url: url,
      method: "PUT",
      body: {
        uris: first100IDs.map((id) => {
          return "spotify:track:" + id;
        }),
      },
      onSuccessCallback: () => {},
      onFailureCallback: () => {},
    });

    this.addSurplusSongsToSpotifyPlaylist(ids, 100);
  };

  addSurplusSongsToSpotifyPlaylist = (allSongIDs, numSongsAdded) => {
    if (numSongsAdded >= allSongIDs.length) {
      return;
    }

    const { id } = this.props;

    const idsToAdd = allSongIDs.slice(numSongsAdded, numSongsAdded + 100);

    const url = new URL(`https://api.spotify.com/v1/playlists/${id}/tracks`);
    makeSpotifyAPIRequest({
      url: url,
      method: "POST",
      body: {
        uris: idsToAdd.map((id) => {
          return "spotify:track:" + id;
        }),
      },
      onSuccessCallback: () => {
        this.addSurplusSongsToSpotifyPlaylist(allSongIDs, numSongsAdded + 100);
      },
      onFailureCallback: () => {},
    });
  };

  render() {
    const { classes, id, handleDelete } = this.props;
    const { isOpen, name, rules } = this.state;

    const outerKey = rules.and != null ? "and" : "or";
    const outerValue = rules[outerKey];

    return (
      <Accordion
        className={classes.root}
        expanded={isOpen}
        onChange={this.openOrCloseAccordion}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container>
            <Grid container item xs={12} justify={"space-between"}>
              <Grid container item xs={8} justify="center" direction="column">
                {isOpen ? (
                  <TextField
                    autoFocus
                    value={name}
                    onChange={this.updatePlaylistName}
                    onKeyDown={this.onPlaylistNameKeyDown}
                  />
                ) : (
                  <Typography variant={"h6"} color={"textSecondary"}>
                    {name}
                  </Typography>
                )}
              </Grid>
              <Grid container item xs={4} justify={"flex-end"}>
                <IconButton onClick={() => handleDelete(id)} edge="end">
                  <DeleteIcon color="error" />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <PlaylistRuleGroup
            orderPosition={-1}
            operator={outerKey}
            subConfig={outerValue}
            isParentGroup={true}
            onChangeOperator={this.onChangeOuterOperator}
            onChangeSubConfig={this.onChangeOuterValue}
            onDelete={() => {}}
          />
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default withStyles(useStyles)(PlaylistAccordion);
